import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { performanceModel } from '../model/index';

@Injectable()
export class PerformanceService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private performanceUrl = 'api/performance';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getPerformanceList(query: any): Promise<performanceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.performanceUrl}/getPerformanceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deletePerformance(performance_id: any): Promise<performanceModel> {
        const url = `${this.performanceUrl}/deletePerformance`;
        return this.http
            .post(url, $.param({ performance_id: performance_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as performanceModel)
            .catch(this.handleError);
    }

    addUpdatePerformance(performanceData: any): Promise<performanceModel> {

        const url = `${this.performanceUrl}/addUpdatePerformance`;

        return this.http
            .post(url, $.param(performanceData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as performanceModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/performance.service.ts